import { render, staticRenderFns } from "./PageMessages.vue?vue&type=template&id=51c12c8e&"
import script from "./PageMessages.vue?vue&type=script&lang=js&"
export * from "./PageMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports